import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Typography, Container, Box } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import AiKnowledgeList from '../../components/AiKnowledgeList';
import AiKnowledgeForm from '../../components/AiKnowledgeForm';

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: theme.spacing(3),
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(4),
    paddingBottom: theme.spacing(3),
    borderBottom: '2px solid #e5e7eb'
  },
  title: {
    fontSize: '28px',
    fontWeight: 700,
    color: '#1f2937',
    margin: 0
  },
  button: {
    padding: theme.spacing(1.5, 3),
    backgroundColor: '#3b82f6',
    color: 'white',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 600,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#2563eb',
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 8px rgba(59, 130, 246, 0.3)'
    }
  },
  cancelButton: {
    padding: theme.spacing(1.25, 2.5),
    backgroundColor: '#6b7280',
    color: 'white',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 600,
    textTransform: 'none',
    marginTop: theme.spacing(3),
    '&:hover': {
      backgroundColor: '#4b5563',
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 8px rgba(107, 114, 128, 0.3)'
    }
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: '800px',
    margin: '0 auto'
  },
  formTitle: {
    fontSize: '24px',
    fontWeight: 600,
    color: '#374151',
    marginBottom: theme.spacing(4),
    textAlign: 'center'
  },
  icon: {
    marginRight: theme.spacing(1)
  }
}));

const KnowledgeBase = () => {
  const [showForm, setShowForm] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [refreshList, setRefreshList] = useState(0);
  const classes = useStyles();

  const handleNew = () => {
    setEditingItem(null);
    setShowForm(true);
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setShowForm(true);
  };

  const handleSave = () => {
    setShowForm(false);
    setEditingItem(null);
    setRefreshList(prev => prev + 1);
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingItem(null);
  };

  return (
    <Container className={classes.container}>
      <Box className={classes.header}>
        <Typography variant="h4" className={classes.title}>
          Base de Conhecimento IA
        </Typography>
        {!showForm && (
          <Button
            variant="contained"
            onClick={handleNew}
            className={classes.button}
            startIcon={<AddIcon />}
          >
            Novo Conhecimento
          </Button>
        )}
      </Box>

      {showForm ? (
        <Box className={classes.formContainer}>
          <Typography variant="h5" className={classes.formTitle}>
            {editingItem ? 'Editar Conhecimento' : 'Novo Conhecimento'}
          </Typography>
          <AiKnowledgeForm
            initialData={editingItem}
            onSave={handleSave}
          />
          <Button
            variant="contained"
            onClick={handleCancel}
            className={classes.cancelButton}
          >
            Cancelar
          </Button>
        </Box>
      ) : (
        <AiKnowledgeList key={refreshList} onEdit={handleEdit} />
      )}
    </Container>
  );
};

export default KnowledgeBase;